module.exports = __webpack_public_path__ + "static/media/historia.0765a371.png";